import React, { useState } from 'react';
import '../products_top/ProductsTop.css';
import ReusableProductsTop from '../organic1-reusable/ReusableProductsTop';
import { Container, Row } from 'react-bootstrap';

const ProductsTop = () => {
  const [showMore, setShowMore] = useState(false);

  const handleToggleSeeMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <section id="products_top">
        <Container>
        <h1>Top rated products</h1>
          <p className={`products_top_see ${showMore ? 'active' : ''}`} onClick={handleToggleSeeMore}>
            shop all <i className="fa-solid fa-arrow-right-long"></i>
          </p>
          <Row>
            <ReusableProductsTop img="imeges/desktop1/coriander leaves.png"/>
            <ReusableProductsTop img="imeges/desktop1/broccoli.png"/>
            <ReusableProductsTop img="imeges/desktop1/rar halid.png"/>
          </Row>
          {showMore && (
            <Row className="products_see_more">
              <ReusableProductsTop img="imeges/desktop1/broccoli.png" />
              <ReusableProductsTop img="imeges/desktop1/rar halid.png" />
              <ReusableProductsTop img="imeges/desktop1/coriander leaves.png" />
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};

export default ProductsTop;
